export const getBookImage = (book) => {
  if (book.product) {
    return book.product.thumbnail;
  } else if (book.images?.length) {
    const img = book.images[0];
    return `${img.bucketUrl}/${img.filename}`;
  }

  return null;
};
